import { FormatCurrency } from '@wolfejs/ui/Format';
import { cn } from '@wolfejs/ui/utils/classnames';

export type CartLineItemPriceProps = {
  className?: string;
  price: number;
};

export const CartLineItemPrice = ({ className, price }: CartLineItemPriceProps) => {
  return <FormatCurrency className={cn('', className)} numberFormatBaseProps={{ value: price, displayType: 'text' }} />;
};
